import { Button } from "../ui/button";
import { useAdvanceProgramProgress } from "../../lib/client/advanceProgramProgress";

interface NextLessonProps {
  userId: number;
  program: string;
  lastLessonCompleted: number;
}

export const NextLesson = ({
  userId,
  program,
  lastLessonCompleted,
}: NextLessonProps) => {
  const advanceProgress = useAdvanceProgramProgress();

  const handleNextLesson = () => {
    advanceProgress.mutate({ userId, program });
  };

  return (
    <div className="flex justify-start">
      <Button onClick={handleNextLesson} disabled={advanceProgress.isPending}>
        {advanceProgress.isPending ? "Loading..." : "Go To Next Lesson"}
      </Button>
    </div>
  );
};
